import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFileErrorFn = /* @__PURE__ */ createRecipe('input-file-error', {}, [])

const inputFileErrorVariantMap = {}

const inputFileErrorVariantKeys = Object.keys(inputFileErrorVariantMap)

export const inputFileError = /* @__PURE__ */ Object.assign(memo(inputFileErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFileError',
  __getCompoundVariantCss__: inputFileErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFileErrorVariantKeys,
  variantMap: inputFileErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFileErrorVariantKeys)
  },
  getVariantProps: inputFileErrorFn.getVariantProps,
})